/**
 * CapabilityPillars — BLOCK 02 · 역량(3개 기둥)
 * 모든 문구는 copy.js(CAPABILITY)에서 가져옴. 하드코딩 0.
 */
import { useScrollAnimation } from '../../hooks/useScrollAnimation';
import styles from '../../styles/CapabilityPillars.module.css';
import { CAPABILITY } from './copy';

export default function CapabilityPillars() {
  const [ref, isVisible] = useScrollAnimation({ once: true });

  return (
    <section
      id="capability"
      ref={ref}
      className={`section ${styles.capability} ${isVisible ? styles.visible : ''}`}>
      <div className={styles.inner}>
        <h2 className={styles.head}>{CAPABILITY.head}</h2>

        <div className={styles.grid}>
          {CAPABILITY.pillars.map((pillar) => (
            <div key={pillar.title} className={styles.card}>
              <span className={styles.bar} aria-hidden="true" />
              <h3 className={styles.cardTitle}>{pillar.title}</h3>
              <p className={styles.cardBody}>{pillar.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
